// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure KaTeX math rendering works well with our design */
.math-content {
  line-height: 1.6;
}

.math-content .katex {
  font-size: inherit;
}

.math-content .katex-display {
  margin: 1em 0;
  text-align: center;
}

.math-content .katex-display > .katex {
  display: inline-block;
  white-space: nowrap;
}

/* Ensure proper sizing in different contexts */
.text-sm .math-content .katex {
  font-size: 0.875rem;
}

.text-lg .math-content .katex {
  font-size: 1.125rem;
}

/* Dark mode support */
.dark .math-content .katex {
  color: inherit;
}

/* Responsive math for mobile */
@media (max-width: 640px) {
  .math-content .katex-display {
    overflow-x: auto;
    overflow-y: hidden;
  }
  
  .math-content .katex-display > .katex {
    white-space: nowrap;
  }
}

/* Integration with prose styles */
.prose .math-content .katex {
  color: inherit;
}

.prose .math-content .katex-display {
  margin: 1.5em 0;
}

/* Error styling for failed math expressions */
.math-content .text-red-500 {
  background-color: rgba(239, 68, 68, 0.1);
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  border: 1px solid rgba(239, 68, 68, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/math.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kCAAkC;AAClC;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C","sourcesContent":["/* Ensure KaTeX math rendering works well with our design */\n.math-content {\n  line-height: 1.6;\n}\n\n.math-content .katex {\n  font-size: inherit;\n}\n\n.math-content .katex-display {\n  margin: 1em 0;\n  text-align: center;\n}\n\n.math-content .katex-display > .katex {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n/* Ensure proper sizing in different contexts */\n.text-sm .math-content .katex {\n  font-size: 0.875rem;\n}\n\n.text-lg .math-content .katex {\n  font-size: 1.125rem;\n}\n\n/* Dark mode support */\n.dark .math-content .katex {\n  color: inherit;\n}\n\n/* Responsive math for mobile */\n@media (max-width: 640px) {\n  .math-content .katex-display {\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n  \n  .math-content .katex-display > .katex {\n    white-space: nowrap;\n  }\n}\n\n/* Integration with prose styles */\n.prose .math-content .katex {\n  color: inherit;\n}\n\n.prose .math-content .katex-display {\n  margin: 1.5em 0;\n}\n\n/* Error styling for failed math expressions */\n.math-content .text-red-500 {\n  background-color: rgba(239, 68, 68, 0.1);\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
